import * as types from "./actionsTypes";

export function setFormations(formations) {
  return {
    type: types.SET_FORMATIONS,
    data: formations,
  };
}

export function resetFormations() {
  return {
    type: types.RESET_FORMATIONS,
  };
}
